export enum SLLocalStorageKey {
	TIA_V3_FILTERS_TABLE = 'data-tia-v3-filters-table',
	MESSAGES = 'messages',
	DATADOG_RUM = 'rum',
}
